/* asv-cro.20260927.js — Conversion-Schicht vom 27.09.2026.
   Laeuft defer. Jede Funktion prueft selbst, ob ihre Seite vorliegt. */
(() => {
  const body = document.body;

  /* 1 — Produktseite, Handy: Kaufleiste auch beim Laden zeigen, solange sie
     keine Produktbedienung überdeckt. Das Theme zeigt
     sie erst, wenn das Formular oben herausgerollt ist (gemessen ab scrollY
     ~1300), und blendet sie am Seitenende wieder aus.

     Massgeblich ist die echte Theme-Variante samt Formular-ID. Eine gueltige
     verfuegbare Auswahl darf direkt kaufen, auch ohne variant-URL. Fehlt die
     Auswahl, fuehrt die Leiste zur Auswahl. Waehrend eines Variantenwechsels
     darf sie nicht die vorherige Variante kaufen. */
  if (body.classList.contains('vorlage-product')) {
    const schmal = matchMedia('(max-width: 699px)');
    const picker = () => document.querySelector('.product-info variant-picker, .product-info .variant-picker');
    let wechselt = false, wechselFehler = false, wechselZahl = 0;
    let letzteWahl = Promise.resolve();
    const WAEHLEN = 'Ausführung wählen';

    const auswahl = () => {
      const p = picker();
      if (!p || wechselFehler) return null;
      const v = p.selectedVariant;
      const form = document.forms[p.getAttribute('form-id')];
      const id = form?.elements.namedItem('id')?.value;
      return v?.id && String(v.id) === id ? v : null;
    };

    const beschrifte = () => {
      const k = document.querySelector('.product-sticky-bar button[type="submit"]');
      if (!k) return;
      const p = picker(), v = auswahl();
      if (p && typeof p.selectCombination !== 'function') return;
      const ziel = [...k.querySelectorAll('*')].reverse().find(e => e.children.length === 0 && e.textContent.trim()) || k;
      if (!ziel.dataset.asvText) ziel.dataset.asvText = ziel.textContent;
      const knoepfe = [k, ...document.querySelectorAll('.product-info buy-buttons button[type="submit"]')];
      for (const knopf of knoepfe) {
        if (wechselt || wechselFehler) {
          if (!knopf.dataset.asvWartet) knopf.dataset.asvWartet = String(knopf.disabled);
          knopf.disabled = true;
        } else if (knopf.dataset.asvWartet) {
          knopf.disabled = knopf.dataset.asvWartet === 'true';
          delete knopf.dataset.asvWartet;
        }
      }
      // Nur der mobil durch den Capture-Handler geschuetzte Auswahlknopf wird aktiv.
      if (p && !v && !wechselt && !wechselFehler) k.disabled = !schmal.matches;
      const soll = wechselFehler ? 'Auswahl nicht geladen' : wechselt ? 'Auswahl wird geladen …' : p && !v && schmal.matches ? WAEHLEN : ziel.dataset.asvText;
      if (ziel.textContent !== soll) ziel.textContent = soll;
    };

    // Das Theme rendert jede Antwort. Serialisieren verhindert, dass eine
    // ältere Antwort nach der jüngsten Auswahl Preis/Formular überschreibt.
    const vorbereiten = () => {
      const p = picker();
      if (!p || p.dataset.asvGeregelt || typeof p.selectCombination !== 'function') return;
      const nativerWechsel = p.selectCombination;
      p.dataset.asvGeregelt = 'true';
      p.selectCombination = function(optionen) {
        wechselZahl++;
        wechselt = true;
        wechselFehler = false;
        beschrifte();
        const ausfuehren = letzteWahl.catch(() => {}).then(() => nativerWechsel.call(picker(), optionen));
        letzteWahl = ausfuehren;
        return ausfuehren.then(
          value => {
            wechselFehler = false;
            return value;
          },
          error => {
            wechselFehler = true;
            throw error;
          },
        ).finally(() => {
          wechselZahl--;
          wechselt = wechselZahl > 0;
          plane();
        });
      };
    };

    let wartet = false;
    const pruefe = () => {
      wartet = false;
      const k = document.querySelector('.product-info buy-buttons, .product-info .buy-buttons');
      if (!k) return;
      const leiste = document.querySelector('.product-sticky-bar')?.getBoundingClientRect();
      // Eine feste Kaufleiste darf weder den Hauptknopf noch erreichbare
      // Versandlinks/Optionsfelder verdecken. Ihre Box bleibt bei visibility
      // hidden messbar, damit die Entscheidung nicht hin und her springt.
      const verdeckt = schmal.matches && leiste &&
        [...document.querySelectorAll('.product-info a, .product-info button, .product-info summary, .product-info input:not(.sr-only):not([type="hidden"]), .product-info select, .product-info variant-picker label')].some(e => {
          const box = e.getBoundingClientRect(), stil = getComputedStyle(e);
          return stil.visibility !== 'hidden' && stil.display !== 'none' &&
            box.width > 0 && box.height > 0 && box.bottom > Math.max(0, leiste.top) &&
            box.top < Math.min(innerHeight, leiste.bottom) && box.right > leiste.left && box.left < leiste.right;
        });
      body.classList.toggle('asv-kauf-weg', schmal.matches && !verdeckt);
      body.classList.toggle('asv-kauf-ueberdeckt', !!verdeckt);
      vorbereiten();
      beschrifte();
    };
    const plane = () => { if (!wartet) { wartet = true; requestAnimationFrame(pruefe); } };
    addEventListener('scroll', plane, { passive: true });
    addEventListener('resize', plane);
    new MutationObserver(plane).observe(document.querySelector('main') || body, { childList: true, subtree: true });
    plane();
    customElements.whenDefined('variant-picker').then(plane);

    document.addEventListener('change', e => {
      if (e.target.matches('input[data-option-position]') && picker()?.contains(e.target)) {
        vorbereiten();
        wechselt = true;
        beschrifte();
      }
    }, true);
    document.addEventListener('variant:change', e => {
      if (e.target === document.forms[picker()?.getAttribute('form-id')]) {
        wechselt = wechselZahl > 0;
        plane();
      }
    });
    document.addEventListener('submit', e => {
      if ((wechselt || wechselFehler) && e.target === document.forms[picker()?.getAttribute('form-id')]) {
        e.preventDefault(); e.stopImmediatePropagation();
      }
    }, true);
    document.addEventListener('click', e => {
      const native = e.target.closest('.product-info buy-buttons button[type="submit"], .product-sticky-bar button[type="submit"]');
      if (native && (wechselt || wechselFehler)) {
        e.preventDefault(); e.stopImmediatePropagation(); return;
      }
      const k = e.target.closest('.product-sticky-bar button[type="submit"]');
      if (!k || !schmal.matches || !picker()) return;
      const v = auswahl();
      if (!wechselt && v?.available && !k.disabled) return;
      e.preventDefault(); e.stopImmediatePropagation();
      picker().scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, true);
  }

  /* 2 — Technische Daten (asv-cro.20260927.css, Abschnitt 10): passendes
     Icon je Zeile, Tippfehler der Katalogdaten nur in der Anzeige
     korrigieren, Variantenlisten "1) … 2) …" aus einer Zelle in Zeilen
     teilen. Reihenfolge der Regeln zaehlt: die erste passende gewinnt. */
  const ICONS = [
    ['sliders', /^variante|^\d{4}-\d{2}|ausführung|typ\b|^art\b|format|modell|^module/i],
    ['zap', /spannung|\(u[cp]\)|schutzpegel|volt/i],
    ['thermometer', /temp/i],
    ['droplet', /schutzart|\bip\b|wasser|feucht/i],
    ['shield', /schutzklasse|stoß|schlag|flamm|halogen|\buv|brand|sicherheit/i],
    ['gauge', /strom|ableit|leistung|kurzschluss|belastbar|ausschalt|schaltvermo|auslöse|frequenz|watt/i],
    ['lightbulb', /leucht|sockel|fassung|lichtstrom|abstrahl|farbwiedergabe|energieeffizienz|lumen|lampe/i],
    ['palette', /farbe/i],
    ['layers', /material|gehäuse|tür|front|oberfläche|abdeck/i],
    ['ruler', /abmess|maß|größe|länge|breite|höhe|tiefe|querschnitt|teilungseinheit|durchmesser|gewicht|reichweite|winkel/i],
    ['timer', /zeit|dauer|zyklen|geschwindigkeit/i],
    ['wrench', /montage|hutschiene|einbau|befestigung|install/i],
    ['plug', /anschl|stecker|usb|hdmi|ethernet|\baux|klemm|leiter|pol|kabel|buchse|steckdose/i],
    ['pruefsiegel', /norm|zert|prüf|garantie|\bvde\b/i],
    ['tag', /marke|hersteller|artikelnummer|\bean\b/i],
    ['package', /lieferumfang|zubehör|bestell|inhalt|verpackung|menge|stück/i],
    ['dokument', /anleitung|video|datenblatt|hinweis/i],
    ['sliders', /anzahl|version|charakteristik/i],
  ];
  const TIPPFEHLER = {
    'Temparaturbeständigkeit': 'Temperaturbeständigkeit',
    'Montagenart': 'Montageart',
    'Zertifkat': 'Zertifikat',
    'Zertifkat/Norm': 'Zertifikat/Norm',
    'vorhander zusätzlicher Lieferumfang': 'vorhandener zusätzlicher Lieferumfang',
    'Kurzschlussschaltvermo¨gen': 'Kurzschlussschaltvermögen',
    'Anschlüsse/td>': 'Anschlüsse',
  };
  document.querySelectorAll('.asv-beschr__daten dl > div').forEach(zeile => {
    const dt = zeile.querySelector('dt'), dd = zeile.querySelector('dd');
    if (!dt) return;
    const roh = dt.textContent.trim().replace(/\s*:$/, '');
    const name = TIPPFEHLER[roh] || roh;
    if (name !== dt.textContent) dt.textContent = name;
    // Formelzeichen und Einheiten in Klammern (Uc, Imax, µs) nicht in
    // Versalien: aus "8/20 µs" wuerde sonst "8/20 MS".
    const klammer = name.indexOf(' (');
    if (klammer > 0) {
      const zusatz = document.createElement('span');
      zusatz.className = 'asv-td__zusatz';
      zusatz.textContent = name.slice(klammer);
      dt.textContent = name.slice(0, klammer);
      dt.append(zusatz);
    }
    const treffer = ICONS.find(([, re]) => re.test(name));
    if (treffer) zeile.dataset.ico = treffer[0];

    if (!dd || dd.children.length) return;
    const teile = dd.textContent.trim().split(/(?:^|\s)(\d{1,2})\)\s/);
    if (teile.length < 5) return; // weniger als zwei Varianten: Text bleibt
    const liste = document.createElement('ul');
    liste.className = 'asv-td__liste';
    for (let i = 1; i < teile.length; i += 2) {
      const text = teile[i + 1].trim(), art = text.match(/^(\d{4}-\d{2})\s*:\s*/);
      const li = document.createElement('li'), nr = document.createElement('span'), rest = document.createElement('span');
      nr.className = 'asv-td__nr';
      nr.textContent = art ? art[1] : teile[i];
      rest.textContent = art ? text.slice(art[0].length) : text;
      li.append(nr, rest);
      liste.append(li);
    }
    dd.textContent = '';
    if (teile[0].trim()) {
      const intro = document.createElement('span');
      intro.className = 'asv-td__intro';
      intro.textContent = teile[0].trim();
      dd.append(intro);
    }
    dd.append(liste);
  });
})();
